import lodash from "lodash";
import { conditionFormChecker, putField } from "../../../../../utils/form";
import { mergeChildrenAll } from "../../../../../utils/util";
import {
    createFieldAttachment,
    createFieldCheckbox,
    createFieldDate,
    createFieldInput,
    createFieldInputNumber,
    createFieldRadioGroup,
    createFieldSelect,
    createFieldTemplateBuilder,
    createFieldTextArea,
} from "../../../../../components/input/template-builder/template-builder.logic";
import i18n from "../../../../../i18n";
import { callReceiverDepartment } from "../request.section";
import store from "../../../../../store";
import { getDeep } from "../../../../../utils/list";
import { defineAsyncComponent } from "vue";
import { Divider, Button } from "ant-design-vue";
import { callCompanyType } from "../../../../account/register/register.section";
import { openModalForm as openModalKadeeForm } from "../../modal/kadee.logic";
import { callAppealStatus } from "../../../license/license.section";
const CIcon = defineAsyncComponent(() => import("../../../../../components/icon/CIcon"));
import { dateFormat } from "../../../../../utils/date";
import { has } from "../../../../../utils/menu-context";

export const callPersonType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "PERSON_TYPE", value: searchQuery });

export const callAllUser = ({ searchQuery }) => store.dispatch("resource/v1/security/user/cacheFindAll", { searchQuery });

export const callMyUserRole = ({ userId }) =>
    store.dispatch("resource/v1/security/userRole/cacheFindAll", {
        where: [{ name: "refUser.id", type: "UUID", operator: "=", value: userId }],
        sort: [],
        criteria: {
            select: ["**"],
            children: [
                {
                    name: "refUser.addresses",
                    select: ["*", "refAddressType.*", "refProvince.*", "refAmphur.*", "refTambon.*"],
                    page: 0,
                    size: 1,
                    where: [{ name: "refId", type: "UUID", operator: "=", value: userId }],
                },
            ],
        },
    });

export const callFishermanUser = ({ searchQuery }) =>
    store
        .dispatch("resource/v1/security/userRole/cacheFindAll", {
            where: [{ name: "refRole.name", type: "String", operator: "=", value: "FISHERMAN" }],
            sort: [{ name: "refUser.username", type: "ASC" }],
            criteria: {
                select: ["**"],
            },
        })
        .then((fishery) => {
            const userIdCards = fishery.map((users) => users.refUser.idCard);
            return callAllUser({ searchQuery }).then((users) => getDeep({ items: users, findFunc: ({ item }) => userIdCards.includes(item.idCard) }));
        });

export const callUsers = ({ searchQuery }) => {
    return store
        .dispatch("resource/v1/master/fishingTool/search", {
            criteria: {
                select: ["**"],
                page: 0,
                size: 100000,
                where: [
                    { openBucket: true, name: "nameTh", type: "String", operator: "like", value: searchQuery },
                    { logic: "OR", closeBucket: true, name: "nameEn", type: "String", operator: "like", value: searchQuery },
                    { name: "isActive", type: "Boolean", operator: "=", value: true },
                ],
                sort: [{ name: "nameTh", type: "ASC" }],
                children: [],
            },
        })
        .then((page) => page.data);
};

export const callTitle = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "TITLE", value: searchQuery });

export const callNationality = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "NATIONALITY", value: searchQuery });

export const callFishingArea = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "FISHING_AREA", value: searchQuery });

export const callRequestType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_TYPE", value: searchQuery });

export const callProvince = () => store.dispatch("resource/v1/master/province/cacheFindAll");

export const callLicenseRequestStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "LICENSE_REQUEST_STATUS", value: searchQuery });

export const callLicenseRequestReStatus = ({ searchQuery, data }) => {
    const where = [
        { name: "key", type: "String", operator: "in", value: ["draft", "waitModify", "waitArgueLawyer", "cancel", "waitAcceptRequest", "waitRDAudit", "waitLawyerAudit", "waitDofCenterAudit", "waitApprove", "notApprove", "appeal"] },
    ];
    if (!(["requestLicense", "renewLicense", "transferLicense"].includes(data.form?.refRequestType?.key) ||
            ("changeLicense" === data.form?.refRequestType?.key && ["replaceBoat"].includes(data.form?.refChangeLicenseObjective?.key))
        )) {
        where.push({ name: "key", type: "String", operator: "=", isNot: true, value: "waitLawyerAudit" });
    }
    if (!("changeLicense" === data.form?.refRequestType?.key && ["tool", "moveAshore"].includes(data.form?.refChangeLicenseObjective?.key))) {
        where.push({ name: "key", type: "String", operator: "=", isNot: true, value: "waitRDAudit" });
    }
    return store
        .dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "LICENSE_REQUEST_STATUS", value: searchQuery, where })
        .then((items) =>
            items.filter((item) => {
                return item.seq <= data.statusCurrent?.seq || item.seq <= 50;
            })
        );
};

export const callResultConsideration = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "RESULT_OF_CONSIDERATION", value: searchQuery });

export const callArgueLawyerConsiderationStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "ARGUE_LAWYER_STATUS", value: searchQuery });

export const callLicenseRequestAttachment = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "LICENSE_REQUEST_ATTACHMENT", value: searchQuery, options: { sort: [{ name: "key", type: "asc" }] } });

export const callAddressType = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "ADDRESS_TYPE", value: searchQuery });

export const callConsiderApplicant = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "INSPECTION_APPLICANT", value: searchQuery });

export const callConsiderVessel = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "INSPECTION_VESSEL", value: searchQuery });

export const callPreviewVesselRequestAttachment = () =>
    store.dispatch("resource/v1/master/attachment/cacheFindAllByModel", { model: "PreviewVesselRequest" });

export const callLifeStatus = ({ searchQuery }) =>
    store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "LIFE_STATUS", value: searchQuery });

export const callKadee = ({ pid, shipCode }) => {
    return store.dispatch("resource/v1/ws/kadeeResource/queryKadee", { pid, shipCode }).then((page) => page);
};

const Address = defineAsyncComponent(() => import("../../../../../components/address/Address"));

export const callSearchLicense = ({ searchQuery, userInfo, refLicenseStatusKey = "active", moreWhere = [], props, data }) => {
    const userDepartment =  store.state.resource.auth.info?.department;
    const { menuContext } = props;
    let where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "approve" },
        { name: "refLicenseStatus.key", type: "String", operator: "=", value: refLicenseStatusKey },
        { name: "refOwner.username", type: "String", operator: "=", value: userInfo?.username }
    ];
    if (moreWhere.length > 0) {
        where.push(...moreWhere);
    }
    const currentUserIsOfficerCanActRequester = (has({ menuContext, key: "forSendRequest"}) || has({ menuContext, key: "forReviewRequest"})) && !["PEOPLE", "FISHERMAN"].includes(data.myRole?.name);
    if (currentUserIsOfficerCanActRequester) {
        where = where.filter(it => it.name != "refOwner.username");

        console.log('has({ menuContext, key: "viewOnlyInProvince" })', has({ menuContext, key: "viewOnlyInProvince" }))
        console.log('has({ menuContext, key: "viewOnlyInProvince" })', has({ menuContext, key: "viewOnlyInAmphur" }))
        if (has({ menuContext, key: "viewOnlyInProvince" })) {
            where.push({ name: "refReceiveDept.refProvince.id", type: "UUID", operator: "=", value: userDepartment?.refProvince?.id })
        } else if (has({ menuContext, key: "viewOnlyInAmphur" })) {
            where.push({ name: "refReceiveDept.refAmphur.id", type: "UUID", operator: "=", value: userDepartment?.refAmphur?.id })
        } else {
            where.push({ name: "refOwner.username", type: "String", operator: "=", value: userInfo?.username })
        }
    }
    if (searchQuery) {
        where.push({ name: "licenseCode", type: "String", operator: "like", value: searchQuery });
    }

    return store
        .dispatch("resource/v1/transaction/licenseRequest/search", {
            criteria: {
                isDistinct: false,
                select: ["id", "licenseCode"],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "licenseCode", type: "ASC" }],
            },
        })
        .then((page) => page.data);
};

export const callSearchLicenseFull = ({ id }) => {
    return store
        .dispatch("resource/v1/transaction/licenseRequest/search", {
            criteria: {
                isDistinct: false,
                select: ["**", "refRequester.**", "refOwner.**"],
                page: 0,
                size: 1,
                where: [{ name: "id", type: "UUID", operator: "=", value: id }],
                children: [
                    {
                        name: "addresses",
                        select: ["*", "refAddressType.*", "refProvince.*", "refAmphur.*", "refTambon.*"],
                        page: 0,
                        size: 1,
                        where: [
                            { name: "refId", type: "UUID", operator: "=", value: id },
                            { name: "model", type: "String", operator: "=", value: "LicenseRequest" },
                        ],
                    },
                    {
                        name: "addressOwners",
                        select: ["*", "refAddressType.*", "refProvince.*", "refAmphur.*", "refTambon.*"],
                        page: 0,
                        size: 1,
                        where: [
                            { name: "refId", type: "UUID", operator: "=", value: id },
                            { name: "model", type: "String", operator: "=", value: "LicenseOwner" },
                        ],
                    },
                    {
                        name: "fishingToolRequests",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [],
                    },
                    {
                        name: "fishingToolDeclarations",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [],
                    },
                    {
                        name: "refVesselRequest.vesselOwnerRequests",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [],
                    },
                    {
                        name: "refVesselRequest.attachmentVesselIdentities",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [],
                    },
                    {
                        name: "refVesselRequest.attachmentPositionVesselIdentities",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [],
                    },
                    {
                        name: "refVesselRequest.attachmentHeadVessels",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [],
                    },
                    {
                        name: "refVesselRequest.attachmentFullVessels",
                        select: ["**"],
                        page: 0,
                        size: 1000000,
                        sort: [{ name: "createDate", type: "ASC" }],
                        children: [],
                    },
                ],
            },
        })
        .then((page) => page.data[0]);
};

export const createField = ({ props, data, key, isLoading }) => {
    // const { viewOnly, menuContext } = props;
    // const { useForm } = data;
    // const { modelRef } = useForm;
    // const model = key ? lodash.get(modelRef, key) : modelRef;
    // const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            ...createFieldRequestDetail({ props, data, key }),
            ...createFieldRequester({ props, data, key, isLoading }),
            ...createFieldAttorney({ props, data, key }),
            ...createFieldFishingArea({ props, data, key }),
            ...createFieldWorker({ props, data, key }),
            // ...createFieldCancelRequest({ props, data, key }),
        ],
    });
};

export const createFieldCancelRequest = ({ props, data, key }) => {
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}cancelRequest`,
                cardBorderProp: () =>
                    modelRef.isCancelRequest
                        ? { title: i18n.global.t("views.request.licenseRequest.cancelRequest"), headerSize: "small", class: "mt-3" }
                        : false,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24, md: 24 } }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldCheckbox({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}isCancelRequest`,
                            colProp: () => ({ xs: 24, md: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("model.licenseRequest.isCancelRequest"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        checked: model.isCancelRequest,
                                        "onUpdate:checked": (checked) => {
                                            model.isCancelRequest = checked;
                                            model.cancelRequestRemark = null;
                                            model.attachmentCancelRequests = [];
                                        },
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),

                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}cancelRequestRemark`,
                            colProp: () => ({ xs: 24, md: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("model.licenseRequest.cancelRequestRemark"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.cancelRequestRemark,
                                        "onUpdate:value": (value) => (model.cancelRequestRemark = value),
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldAttachment({
                            key: `${prefix}attachmentCancelRequests`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => (modelRef.isCancelRequest ? i18n.global.t("model.licenseRequest.attachmentCancelRequests") : ""),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.attachmentCancelRequests,
                                        "onUpdate:value": (value) => (modelRef.attachmentCancelRequests = value),
                                        multiple: true,
                                        disabled: !modelRef.isCancelRequest,
                                        group: "CancelLicenseRequestAttachment",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]}),
                }),
            }),
        ],
    });
};

export const createFieldRequestDetail = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refStatus`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refChangeStatus")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refStatus,
                            "onUpdate:value": (value) => (model.refStatus = value),
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callLicenseRequestReStatus({ searchQuery, data }),
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            {
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refStatus`,
                colProp: () => ({ xs: 24 }),
            },
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}changeStatusRemark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => store.state.resource.auth.info?.roles.map((d) => d.refRole?.name).find((d) => d === "EDIT_LICENSE_STATUS") ? i18n.global.t("model.licenseRequest.changeStatusRemark") : i18n.global.t("model.licenseRequest.changeStatusRemarkFisherman"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.changeStatusRemark,
                            "onUpdate:value": (value) => (model.changeStatusRemark = value),
                            disabled: viewOnly || ["FISHERMAN"].includes(data.myRole?.name),
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}draftCode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.draftCode")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.draftCode,
                            "onUpdate:value": (value) => (model.draftCode = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}requestCode`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.requestCode")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requestCode,
                            "onUpdate:value": (value) => (model.requestCode = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldDate({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: "requestDate",
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.requestDate"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: modelRef.requestDate,
                            "onUpdate:value": (value) => (modelRef.requestDate = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refReceiveDept`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refReceiveDept")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refReceiveDept,
                            "onUpdate:value": (value) => (model.refReceiveDept = value),
                            disabled: viewOnly,
                            list: callReceiverDepartment,
                            optLabel: "nameTh",
                            treeDefaultExpandAll: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.nameTh`) },
            }),
            {
                key: `${prefix}refReceiveDept`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ xs: 24, md: 12 }),
                formItemRender: () => {},
            },
        ],
    });
};

export const createFieldRequester = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequesterPersonType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.refPersonType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequesterPersonType,
                            "onUpdate:value": (value) => (model.refRequesterPersonType = value),
                            disabled: viewOnly,
                            list: callPersonType,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            // createFieldSelect({
            //     visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
            //     key: `${prefix}requesterIdCard`,
            //     colProp: () => ({ xs: 24, md: 12 }),
            //     formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
            //     label: () => `${i18n.global.t("model.licenseRequest.requesterIdCard")}`,
            //     inputProp: ({ field }) =>
            //         lodash.merge(
            //             {
            //                 value: model.refRequester,
            //                 "onUpdate:value": (value) => {
            //                     model.addresses = [];
            //                     model.refRequester = value;
            //                     model.requesterIdCard = value.idCard;
            //                     model.refRequesterTitle = value.refTitle;
            //                     model.requesterFirstName = value.firstNameTh;
            //                     model.requesterLastName = value.lastNameTh;
            //                     model.requesterAge = moment().diff(value.birthDate, "years");
            //                     model.addresses[0] = lodash.cloneDeep(value.addresses?.[0]);
            //                     model.addresses[0].id = null;
            //                     model.addresses[0].version = null;
            //                 },
            //                 disabled: viewOnly,
            //                 list: ({ searchQuery }) => callFishermanUser({ searchQuery }),
            //                 optLabel: "idCard",
            //             },
            //             conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
            //         ),
            //     changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) },
            // }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}requesterIdCard`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () =>
                    modelRef.refRequesterPersonType?.key == "2"
                        ? `${i18n.global.t("model.licenseRequest.requesterIdCard")}`
                        : `${i18n.global.t("model.licenseRequest.taxId")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requesterIdCard,
                            "onUpdate:value": (value) => (model.requesterIdCard = value),
                            disabled: viewOnly,
                            maxlength: 13
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}requesterName`,
                colProp: () => ({ xs: 24, md: 24 , style: { paddingLeft: "8px !important" }}),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.licenseRequest.requesterName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requesterName,
                            "onUpdate:value": (value) => (model.requesterName = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refRequesterCompanyType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refRequesterCompanyType")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequesterCompanyType,
                            "onUpdate:value": (value) => (model.refRequesterCompanyType = value),
                            disabled: viewOnly,
                            list: callCompanyType,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requesterShareholdingTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.requesterShareholdingTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requesterShareholdingTh,
                            "onUpdate:value": (value) => {
                                model.requesterShareholdingTh = value > 100 ? 100 : value;
                            },
                            disabled: viewOnly,
                            comma: true,
                            maxDecimal: 3,
                            allowPrecision: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refRequesterTitle`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refRequesterTitle")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequesterTitle,
                            "onUpdate:value": (value) => (model.refRequesterTitle = value),
                            disabled: viewOnly,
                            list: callTitle,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            {
                key: `${prefix}requesterFirstNameSpace`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ md: 12, xs: 0 }),
                formItemRender: () => {},
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}requesterFirstName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.requesterFirstName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requesterFirstName,
                            "onUpdate:value": (value) => (model.requesterFirstName = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}requesterLastName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.requesterLastName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requesterLastName,
                            "onUpdate:value": (value) => (model.requesterLastName = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}requesterAge`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.requesterAge")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requesterAge,
                            "onUpdate:value": (value) => (model.requesterAge = value),
                            disabled: true,
                            addonAfter: "ปี",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refRequesterNationality`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refNationality")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequesterNationality,
                            "onUpdate:value": (value) => (model.refRequesterNationality = value),
                            disabled: true,
                            list: callNationality,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requesterEmail`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.email"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requesterEmail,
                            "onUpdate:value": (value) => (model.requesterEmail = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}requesterMobile`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.mobile"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.requesterMobile,
                            "onUpdate:value": (value) => (model.requesterMobile = value),
                            comma: false,
                            maxDecimal: 10,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequesterLifeStatus`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.refRequesterLifeStatus"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequesterLifeStatus,
                            "onUpdate:value": (value) => (model.refRequesterLifeStatus = value),
                            disabled: viewOnly,
                            list: callLifeStatus,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            {
                key: `${prefix}addresses.0`,
                visible: () => true,
                colProp: () => ({ xs: 24, md: 24, style: { alignSelf: "center", padding: "0px" }, class: "hr-address-label" }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 3, style: { paddingTop: "0px" } }, wrapperCol: { xs: 24, md: 21 } }),
                label: () => <label style={{ paddingTop: "0px !important", fontWeight: "bold" }}>{i18n.global.t("model.address.modelName")}</label>,
                inputRender: () => (
                    <hr
                        style={{
                            borderTop: "2px dashed #fff",
                            borderBottom: "1px dashed #8c8b8b",
                        }}
                    ></hr>
                ),
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                // formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                // label: () => i18n.global.t("model.address.modelName"),
                inputRender: () => {
                    model?.addresses?.[0]?.id;
                    return () =>
                        !model?.addresses ? (
                            <></>
                        ) : (
                            <Address
                                menuContext={menuContext}
                                viewOnly={viewOnly}
                                dataProp={data}
                                dataKey={`${prefix}addresses.0`}
                                isLoading={isLoading.value}
                            ></Address>
                        );
                },
            },
        ],
    });
};

export const createFieldLicenseOwner = ({ props, data, key, isLoading }) => {
    const { viewOnly, menuContext } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refOwnerPersonType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.refPersonType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOwnerPersonType,
                            "onUpdate:value": (value) => (model.refOwnerPersonType = value),
                            disabled: viewOnly,
                            list: callPersonType,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}ownerIdCard`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () =>
                    modelRef.refOwnerPersonType?.key == "2"
                        ? `${i18n.global.t("model.licenseRequest.ownerIdCard")}`
                        : `${i18n.global.t("model.licenseRequest.taxId")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.ownerIdCard,
                            "onUpdate:value": (value) => (model.ownerIdCard = value),
                            disabled: viewOnly,
                            maxlength: 13
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}ownerName`,
                colProp: () => ({ xs: 24, md: 24 , style: { paddingLeft: "8px !important" }}),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => `${i18n.global.t("model.licenseRequest.ownerName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.ownerName,
                            "onUpdate:value": (value) => (model.ownerName = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refOwnerCompanyType`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refOwnerCompanyType")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOwnerCompanyType,
                            "onUpdate:value": (value) => (model.refOwnerCompanyType = value),
                            disabled: viewOnly,
                            list: callCompanyType,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}ownerShareholdingTh`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.ownerShareholdingTh"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.ownerShareholdingTh,
                            "onUpdate:value": (value) => {
                                model.ownerShareholdingTh = value > 100 ? 100 : value;
                            },
                            disabled: viewOnly,
                            comma: true,
                            maxDecimal: 3,
                            allowPrecision: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refOwnerTitle`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refOwnerTitle")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOwnerTitle,
                            "onUpdate:value": (value) => (model.refOwnerTitle = value),
                            disabled: viewOnly,
                            list: callTitle,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            {
                key: `${prefix}ownerFirstName`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ md: 12, xs: 0 }),
                formItemRender: () => {},
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}ownerFirstName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.ownerFirstName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.ownerFirstName,
                            "onUpdate:value": (value) => (model.ownerFirstName = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}ownerLastName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.ownerLastName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.ownerLastName,
                            "onUpdate:value": (value) => (model.ownerLastName = value),
                            disabled: viewOnly,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}ownerAge`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.ownerAge")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.ownerAge,
                            "onUpdate:value": (value) => (model.ownerAge = value),
                            disabled: true,
                            addonAfter: "ปี",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refOwnerNationality`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refNationality")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOwnerNationality,
                            "onUpdate:value": (value) => (model.refOwnerNationality = value),
                            disabled: true,
                            list: callNationality,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}ownerEmail`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.email"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.ownerEmail,
                            "onUpdate:value": (value) => (model.ownerEmail = value),
                            disabled: true,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInputNumber({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}ownerMobile`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.user.mobile"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.ownerMobile,
                            "onUpdate:value": (value) => (model.ownerMobile = value),
                            comma: false,
                            maxDecimal: 10,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            {
                key: `${prefix}addressOwners.0`,
                visible: () => true,
                colProp: () => ({ xs: 24, md: 24, style: { alignSelf: "center", padding: "0px" }, class: "hr-address-label" }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 3, style: { paddingTop: "0px" } }, wrapperCol: { xs: 24, md: 21 } }),
                label: () => <label style={{ paddingTop: "0px !important", fontWeight: "bold" }}>{i18n.global.t("model.address.modelName")}</label>,
                inputRender: () => (
                    <hr
                        style={{
                            borderTop: "2px dashed #fff",
                            borderBottom: "1px dashed #8c8b8b",
                        }}
                    ></hr>
                ),
            },
            {
                visible: () => true,
                colProp: () => ({ xs: 24 }),
                // formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                // label: () => i18n.global.t("model.address.modelName"),
                inputRender: () => {
                    model?.addressOwners?.[0]?.id;
                    return () =>
                        !model?.addressOwners ? (
                            <></>
                        ) : (
                            <Address
                                menuContext={menuContext}
                                viewOnly={viewOnly}
                                dataProp={data}
                                dataKey={`${prefix}addressOwners.0`}
                                isLoading={isLoading.value}
                            ></Address>
                        );
                },
            },
        ],
    });
};

export const createFieldFishingArea = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refFishingArea`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.refFishingArea"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refFishingArea,
                            "onUpdate:value": (value) => (model.refFishingArea = value),
                            disabled: viewOnly,
                            list: callFishingArea,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            createFieldRadioGroup({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refOriginal.refFishingArea`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.refFishingAreaOld"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refOriginal?.refFishingArea,
                            "onUpdate:value": (value) => (model.refOriginal.refFishingArea = value),
                            disabled: viewOnly,
                            list: callFishingArea,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
        ],
    });
};

export const createFieldAttorney = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldCheckbox({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}isAttorney`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.licenseRequest.isAttorney"),
                labelRender: () => i18n.global.t("model.licenseRequest.isAttorney"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            checked: model?.isAttorney,
                            "onUpdate:checked": (checked) => {
                                model.isAttorney = checked;
                                model.refAttorneyTitle = null;
                                model.attorneyFirstName = null;
                                model.attorneyLastName = null;
                                model.attorneyIdCard = null;
                                model.attorneyPhoneNumber = null;
                            },
                            disabled: viewOnly,
                            text: () => i18n.global.t("model.licenseRequest.attorney"),
                        },
                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                    ),
            }),
            {
                key: `${prefix}isAttorneySpace`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ xs: 24, md: 12 }),
            },

            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}refAttorneyTitle`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.refAttorneyTitle")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refAttorneyTitle,
                            "onUpdate:value": (value) => (model.refAttorneyTitle = value),
                            disabled: viewOnly || !modelRef.isAttorney,
                            list: callTitle,
                            optLabel: "value",
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
            }),
            {
                key: `${prefix}attorneyFirstNameSpace`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ xs: 24, md: 12 }),
            },
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attorneyFirstName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.attorneyFirstName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.attorneyFirstName,
                            "onUpdate:value": (value) => (model.attorneyFirstName = value),
                            disabled: viewOnly || !modelRef.isAttorney,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attorneyLastName`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.attorneyLastName")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.attorneyLastName,
                            "onUpdate:value": (value) => (model.attorneyLastName = value),
                            disabled: viewOnly || !modelRef.isAttorney,
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attorneyIdCard`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.attorneyIdCard")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.attorneyIdCard,
                            "onUpdate:value": (value) => (model.attorneyIdCard = value),
                            disabled: viewOnly || !modelRef.isAttorney,
                            maxlength: 13
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
            createFieldInput({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                key: `${prefix}attorneyPhoneNumber`,
                colProp: () => ({ xs: 24, md: 12 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => `${i18n.global.t("model.licenseRequest.attorneyPhoneNumber")}`,
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.attorneyPhoneNumber,
                            "onUpdate:value": (value) => (model.attorneyPhoneNumber = value),
                            disabled: viewOnly || !modelRef.isAttorney,
                            maxlength: 10
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
            }),
        ],
    });
};

export const createFieldWorker = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}labelWorker`,
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                label: () => <span style="white-space: pre-line">{i18n.global.t("model.licenseRequest.label.worker")}</span>,
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({
                        data,
                        fields: [
                            createFieldCheckbox({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                key: `${prefix}isThaiWorkers`,
                                colProp: () => ({ xs: 24, md: 4 }),
                                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                label: () => i18n.global.t("model.licenseRequest.isThaiWorkers"),
                                labelRender: () => "",
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            checked: model?.isThaiWorkers,
                                            "onUpdate:checked": (checked) => {
                                                model.isThaiWorkers = checked;

                                                if (!model.isThaiWorkers) {
                                                    model.totalThaiWorkers = 0;
                                                    model.thaiMaleWorkers = null;
                                                    model.thaiFemaleWorkers = null;
                                                }
                                            },
                                            disabled: viewOnly,
                                            text: () => i18n.global.t("model.licenseRequest.isThaiWorkers"),
                                        },
                                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                                    ),
                            }),
                            createFieldInput({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                key: `${prefix}totalThaiWorkers`,
                                colProp: () => ({ xs: 24, md: 6 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                                label: () => `${i18n.global.t("model.licenseRequest.totalThaiWorkers")}`,
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.totalThaiWorkers,
                                            "onUpdate:value": (value) => (model.totalThaiWorkers = value),
                                            disabled: true,
                                        },
                                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                    ),
                                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) },
                            }),
                            createFieldInputNumber({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                key: `${prefix}thaiMaleWorkers`,
                                colProp: () => ({ xs: 24, md: 7 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                                label: () => `${i18n.global.t("model.licenseRequest.thaiMaleWorkers")}`,
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.thaiMaleWorkers,
                                            "onUpdate:value": (value) => {
                                                model.thaiMaleWorkers = value;
                                                model.totalThaiWorkers =
                                                    (parseInt(model.thaiMaleWorkers) || 0) + (parseInt(model.thaiFemaleWorkers) || 0);
                                            },
                                            disabled: viewOnly,
                                        },
                                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                    ),
                                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) },
                            }),
                            createFieldInputNumber({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                key: `${prefix}thaiFemaleWorkers`,
                                colProp: () => ({ xs: 24, md: 7 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                                label: () => `${i18n.global.t("model.licenseRequest.thaiFemaleWorkers")}`,
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.thaiFemaleWorkers,
                                            "onUpdate:value": (value) => {
                                                model.thaiFemaleWorkers = value;
                                                model.totalThaiWorkers =
                                                    (parseInt(model.thaiMaleWorkers) || 0) + (parseInt(model.thaiFemaleWorkers) || 0);
                                            },
                                            disabled: viewOnly,
                                        },
                                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                    ),
                                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) },
                            }),
                            createFieldCheckbox({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                key: `${prefix}isForeignWorkers`,
                                colProp: () => ({ xs: 24, md: 4 }),
                                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                                label: () => i18n.global.t("model.licenseRequest.isForeignWorkers"),
                                labelRender: () => "",
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            checked: model?.isForeignWorkers,
                                            "onUpdate:checked": (checked) => {
                                                model.isForeignWorkers = checked;

                                                if (!model.isForeignWorkers) {
                                                    model.totalForeignWorkers = 0;
                                                    model.foreignMaleWorkers = null;
                                                    model.foreignFemaleWorkers = null;
                                                }
                                            },
                                            disabled: viewOnly,
                                            text: () => i18n.global.t("model.licenseRequest.isForeignWorkers"),
                                        },
                                        conditionFormChecker({ props, data, executeKey: "checkboxField", params: { field } })
                                    ),
                                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) },
                            }),
                            createFieldInput({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                key: `${prefix}totalForeignWorkers`,
                                colProp: () => ({ xs: 24, md: 6 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                                label: () => `${i18n.global.t("model.licenseRequest.totalForeignWorkers")}`,
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.totalForeignWorkers,
                                            "onUpdate:value": (value) => (model.totalForeignWorkers = value),
                                            disabled: true,
                                        },
                                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                    ),
                                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) },
                            }),
                            createFieldInputNumber({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                key: `${prefix}foreignMaleWorkers`,
                                colProp: () => ({ xs: 24, md: 7 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                                label: () => `${i18n.global.t("model.licenseRequest.foreignMaleWorkers")}`,
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.foreignMaleWorkers,
                                            "onUpdate:value": (value) => {
                                                model.foreignMaleWorkers = value;
                                                model.totalForeignWorkers =
                                                    (parseInt(model.foreignMaleWorkers) || 0) + (parseInt(model.foreignFemaleWorkers) || 0);
                                            },
                                            disabled: viewOnly,
                                        },
                                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                    ),
                                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) },
                            }),
                            createFieldInputNumber({
                                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                                key: `${prefix}foreignFemaleWorkers`,
                                colProp: () => ({ xs: 24, md: 7 }),
                                formItemProp: () => ({ labelCol: { xs: 24, md: 12 }, wrapperCol: { xs: 24, md: 12 } }),
                                label: () => `${i18n.global.t("model.licenseRequest.foreignFemaleWorkers")}`,
                                inputProp: ({ field }) =>
                                    lodash.merge(
                                        {
                                            value: model.foreignFemaleWorkers,
                                            "onUpdate:value": (value) => {
                                                model.foreignFemaleWorkers = value;
                                                model.totalForeignWorkers =
                                                    (parseInt(model.foreignMaleWorkers) || 0) + (parseInt(model.foreignFemaleWorkers) || 0);
                                            },
                                            disabled: viewOnly,
                                        },
                                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                    ),
                                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}`) },
                            }),
                        ],
                    }),
                }),
            }),
        ],
    });
};

export const createFieldFisheryOfficerConsider = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}forReviewRequest`,
                cardBorderProp: () => ({ title: i18n.global.t("views.request.licenseRequest.considerFisheries"), headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24, class: "mt-4" }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({
                        data,
                        fields: [
                        createFieldRadioGroup({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refFisheriesOfficerStatus`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.resultConsider"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refFisheriesOfficerStatus,
                                        "onUpdate:value": (value) => {
                                            model.refFisheriesOfficerStatus = value;
                                            if (value.key == "agree") {
                                                model.isFisheriesOfficerRemark = null
                                                model.fisheriesOfficerRemark = null
                                                model.isFisheriesOfficerRemark2 = null
                                                model.fisheriesOfficerRemark2 = null
                                            }
                                            model.expireDateToEdit = null;
                                        },
                                        disabled: viewOnly,
                                        list: callResultConsideration,
                                        optLabel: "attribute.anotherText1",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        createFieldDate({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}expireDateToEdit`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.expireDateToEdit"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.expireDateToEdit,
                                        "onUpdate:value": (value) => (model.expireDateToEdit = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldCheckbox({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}isFisheriesOfficerRemark`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 4 }, wrapperCol: { xs: 20 }, colon: false }),
                            label: () => `${i18n.global.t("model.licenseRequest.isFisheriesOfficerRemark")}`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        checked: model.isFisheriesOfficerRemark,
                                        "onUpdate:checked": (checked) => (model.isFisheriesOfficerRemark = checked),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}fisheriesOfficerRemark`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.remarkOfficer"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.fisheriesOfficerRemark,
                                        "onUpdate:value": (value) => (model.fisheriesOfficerRemark = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldCheckbox({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}isFisheriesOfficerRemark2`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 4 }, wrapperCol: { xs: 20 }, colon: false }),
                            label: () => `${i18n.global.t("model.licenseRequest.isFisheriesOfficerRemark2")}`,
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        checked: model.isFisheriesOfficerRemark2,
                                        "onUpdate:checked": (checked) => (model.isFisheriesOfficerRemark2 = checked),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}fisheriesOfficerRemark2`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.remarkOfficer"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.fisheriesOfficerRemark2,
                                        "onUpdate:value": (value) => (model.fisheriesOfficerRemark2 = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldAttachment({
                            key: "attachmentReviewRequests",
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.attachment"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.attachmentReviewRequests,
                                        "onUpdate:value": (value) => (modelRef.attachmentReviewRequests = value),
                                        disabled: viewOnly,
                                        multiple: true,
                                        group: "ReviewRequest",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
        ],
    });
};

export const createFieldLawyerConsider = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}forLawyerAuditor`,
                cardBorderProp: () => ({ title: i18n.global.t("views.request.licenseRequest.forLawyerAuditor"), headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        {
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}searchKadeeRequester`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                            label: () =>
                                modelRef.refRequestType?.key == "transferLicense"
                                    ? i18n.global.t("views.kadee.searchKadeeTransferee")
                                    : i18n.global.t("views.kadee.searchKadeeRequester"),
                            inputRender: () => {
                                return (
                                    <Button
                                        class="btn-primary m-2"
                                        size="small"
                                        onClick={() => {
                                            const { modelRef } = useForm;
                                            let checkIdCard = null;
                                            if (modelRef.refRequestType.key == "transferLicense") {
                                                checkIdCard = modelRef.ownerIdCard;
                                            } else {
                                                checkIdCard = modelRef.requesterIdCard;
                                            }
                                            if (checkIdCard) {
                                                callKadee({ pid: checkIdCard }).then((page) => {
                                                    mergeChildrenAll(page);
                                                    openModalKadeeForm({ props, data: page.data[0] });
                                                });
                                            }
                                        }}
                                    >
                                        {" "}
                                        <span>{i18n.global.t("button.searchKadee")}</span>
                                        <CIcon file={"case-study.svg"}></CIcon>
                                    </Button>
                                );
                            },
                        },
                        {
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}searchKadeeShip`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 10 }, wrapperCol: { xs: 24, md: 14 } }),
                            label: () => i18n.global.t("views.kadee.searchKadeeShip"),
                            inputRender: () => {
                                return (
                                    <Button
                                        class="btn-primary m-2"
                                        size="small"
                                        onClick={() => {
                                            const { modelRef } = useForm;
                                            const shipCode = modelRef?.refVesselRequest?.code;
                                            callKadee({ shipCode }).then((page) => {
                                                mergeChildrenAll(page);
                                                openModalKadeeForm({ props, data: page.data[0] });
                                            });
                                        }}
                                    >
                                        {" "}
                                        <span>{i18n.global.t("button.searchKadee")}</span>
                                        <CIcon file={"case-study.svg"}></CIcon>
                                    </Button>
                                );
                            },
                        },
                        {
                            key: `${prefix}inspectionApplicant`,
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemRender: () => <Divider orientation="left"> { modelRef?.refRequestType?.key == 'transferLicense' ? i18n.global.t("views.section.inspectionOwnerApplicant") : i18n.global.t("views.section.inspectionApplicant")} </Divider>,
                        },
                        ...createFieldCheckboxLawyerConsideration({
                            props,
                            data,
                            isLoading,
                            itemsKey: "licenseRequestInspections",
                            group: "INSPECTION_APPLICANT",
                        }),
                        {
                            key: `${prefix}inspectionVessel`,
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemRender: () => <Divider orientation="left"> {i18n.global.t("views.section.inspectionVessel")} </Divider>,
                        },
                        ...createFieldCheckboxLawyerConsideration({
                            props,
                            data,
                            isLoading,
                            itemsKey: "licenseRequestInspections",
                            group: "INSPECTION_VESSEL",
                        }),
                        createFieldRadioGroup({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refLawyerStatus`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.resultConsider"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refLawyerStatus,
                                        "onUpdate:value": (value) => {
                                            model.refLawyerStatus = value;
                                        },
                                        disabled: viewOnly,
                                        list: callResultConsideration,
                                        optLabel: "value",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        {
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            colProp: () => ({ xs: 24, md: 12 }),
                        },
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}lawyerRemark`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.remarkOfficer"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.lawyerRemark,
                                        "onUpdate:value": (value) => (model.lawyerRemark = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldAttachment({
                            key: "attachmentLawyers",
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.attachment"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.attachmentLawyers,
                                        "onUpdate:value": (value) => (modelRef.attachmentLawyers = value),
                                        disabled: viewOnly,
                                        multiple: true,
                                        group: "Lawyer",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
        ],
    });
};

export const createFieldArgueLawyerConsider = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}argueLawyer`,
                cardBorderProp: () => ({ title: i18n.global.t("views.request.licenseRequest.argueLawyer"), headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldDate({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            key: "argueLawyerDate",
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 4 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.argueLawyerDate"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.argueLawyerDate,
                                        "onUpdate:value": (value) => (modelRef.argueLawyerDate = value),
                                        disabled: viewOnly && modelRef.refArgueLawyerStatus?.key !== "argue",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldRadioGroup({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refArgueLawyerStatus`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.refArgueLawyerStatus"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refArgueLawyerStatus,
                                        "onUpdate:value": (value) => {
                                            model.refArgueLawyerStatus = value;
                                        },
                                        disabled: viewOnly,
                                        list: callArgueLawyerConsiderationStatus,
                                        optLabel: "value",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}argueLawyerRemark`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.argueLawyerRemark"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.argueLawyerRemark,
                                        "onUpdate:value": (value) => (model.argueLawyerRemark = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldAttachment({
                            key: "attachmentArgueLawyers",
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.attachmentArgueLawyers"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.attachmentArgueLawyers,
                                        "onUpdate:value": (value) => (modelRef.attachmentArgueLawyers = value),
                                        disabled: viewOnly,
                                        multiple: true,
                                        group: "ArgueLawyer",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
        ],
    });
};

export const createFieldDofCenterConsider = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}dofCenterConsider`,
                cardBorderProp: () => ({ title: i18n.global.t("views.request.licenseRequest.considerDofCenter"), headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldRadioGroup({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refDofCenterStatus`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.resultConsider"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refDofCenterStatus,
                                        "onUpdate:value": (value) => {
                                            model.refDofCenterStatus = value;
                                        },
                                        disabled: viewOnly,
                                        list: callResultConsideration,
                                        optLabel: "value",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        {
                            key: `${prefix}refDofCenterStatus`,
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            colProp: () => ({ xs: 24, md: 12 }),
                        },
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}dofCenterRemark`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.remarkOfficer"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.dofCenterRemark,
                                        "onUpdate:value": (value) => (model.dofCenterRemark = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldAttachment({
                            key: "attachmentDofCenters",
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.attachment"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.attachmentDofCenters,
                                        "onUpdate:value": (value) => (modelRef.attachmentDofCenters = value),
                                        disabled: viewOnly,
                                        multiple: true,
                                        group: "DofCenter",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
        ],
    });
};

export const createFieldRDConsider = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}forRDAuditor`,
                cardBorderProp: () => ({ title: i18n.global.t("views.request.licenseRequest.considerRD"), headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldRadioGroup({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refRdStatus`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.resultConsider"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refRdStatus,
                                        "onUpdate:value": (value) => {
                                            model.refRdStatus = value;
                                        },
                                        disabled: viewOnly,
                                        list: callResultConsideration,
                                        optLabel: "value",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        {
                            key: `${prefix}refRdStatus`,
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            colProp: () => ({ xs: 24, md: 12 }),
                        },
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}rdRemark`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.remarkOfficer"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.rdRemark,
                                        "onUpdate:value": (value) => (model.rdRemark = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldAttachment({
                            key: "attachmentRDs",
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.attachment"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.attachmentRDs,
                                        "onUpdate:value": (value) => (modelRef.attachmentRDs = value),
                                        disabled: viewOnly,
                                        multiple: true,
                                        group: "RD",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
        ],
    });
};

export const createFieldDirectorConsider = ({ props, data, key, isLoading }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}directorConsider`,
                cardBorderProp: () => ({ title: i18n.global.t("views.request.licenseRequest.considerDirector"), headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24 }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldRadioGroup({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}refDirectorStatus`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.resultConsider"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refDirectorStatus,
                                        "onUpdate:value": (value) => {
                                            model.refDirectorStatus = value;
                                        },
                                        disabled: viewOnly,
                                        list: callResultConsideration,
                                        optLabel: "attribute.anotherText2",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        {
                            key: `${prefix}refDirectorStatus`,
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field, model } }),
                            colProp: () => ({ xs: 24, md: 12 }),
                        },
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}directorRemark`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.remarkDirector"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.directorRemark,
                                        "onUpdate:value": (value) => (model.directorRemark = value),
                                        disabled: viewOnly,
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldAttachment({
                            key: "attachmentDirectors",
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("views.request.licenseRequest.attachment"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.attachmentDirectors,
                                        "onUpdate:value": (value) => (modelRef.attachmentDirectors = value),
                                        disabled: viewOnly,
                                        multiple: true,
                                        group: "Director",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
        ],
    });
};

export const createFieldCheckboxLawyerConsideration = ({ props, data, itemsKey, startPaddingLeft = 128, group }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const itemAlls = itemsKey ? lodash.get(modelRef, itemsKey) : modelRef;
    const items = itemAlls.filter((item) => item.group == group);
    const prefix = itemsKey ? `${itemsKey}.` : "";
    const groupStartAtIndex = items.findIndex((item) => item?.group === group);
    return items
        .map((item, index) => {
            if (!item.refInspectionTopic) {
                return null;
            }
            const attribute = item.refInspectionTopic?.attribute;
            const keyCheck = `${prefix}${index + groupStartAtIndex}.isResult`;

            return createFieldCheckbox({
                visible: () => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field: { key: keyCheck }, items, item } }),
                key: keyCheck,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ wrapperCol: { xs: 24 } }),
                inputProp: () => {
                    const padding = ((attribute?.lv || 1) - 1) * 16;
                    let otherCheckInGroup = false;
                    if (attribute?.checkGroup) {
                        otherCheckInGroup = items.find(
                            (d) =>
                                d.refInspectionTopic.id !== item.refInspectionTopic.id &&
                                d.refInspectionTopic.attribute?.checkGroup === attribute?.checkGroup &&
                                d.isResult
                        );
                    }
                    return lodash.merge(
                        {
                            checked: item?.isResult,
                            "onUpdate:checked": (checked) => {
                                item.isSave = true;
                                item.isResult = checked;
                                if (!checked) {
                                    let childrenInspection = items.filter((d) => {
                                        return item.children?.map((d) => d.id).includes(d?.id);
                                    });
                                    childrenInspection.forEach((d) => {
                                        d.isSave = true;
                                        d.isResult = false;
                                    });
                                }
                            },
                            disabled: !item.refInspectionTopic.attribute?.canCheck && viewOnly && otherCheckInGroup,
                            text: () => `${ modelRef?.refRequestType?.key == "transferLicense" ?  item.refInspectionTopic?.value2: item.refInspectionTopic?.value}`,
                            style: { paddingLeft: `${startPaddingLeft + padding}px` },
                            class: attribute?.visibleCheck ? "" : "hidden-checkbox-only",
                        },
                        conditionFormChecker({ props, data, executeKey: "checkedProp", params: { field: { key: keyCheck }, items, item } })
                    );
                },
            });
        })
        .filter((field) => field);
};

export const createFieldAppealRequest = ({ props, data, key, isLoading }) => {
    // const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldTemplateBuilder({
                key: `${prefix}appealRequestDetail`,
                cardBorderProp: () => ({ title: i18n.global.t("views.request.licenseRequest.appealRequestDetail"), headerSize: "small" }),
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                colProp: () => ({ xs: 24, class: "mt-3" }),
                inputProp: () => ({
                    useForm: useForm,
                    fields: putField({ data, fields: [
                        createFieldRadioGroup({
                            key: `${prefix}refAppealRequestStatus`,
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.licenseRequest.refAppealRequestStatus"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.refAppealRequestStatus,
                                        "onUpdate:value": (value) => {
                                            model.refAppealRequestStatus = value;
                                        },
                                        disabled: conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } }),
                                        list: () => callAppealStatus(),
                                        optLabel: "value",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                            changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) },
                        }),
                        createFieldTextArea({
                            visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                            key: `${prefix}appealRequestRemark`,
                            colProp: () => ({ xs: 24 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 4 }, wrapperCol: { xs: 24, md: 20 } }),
                            label: () => i18n.global.t("model.licenseRequest.appealRequestRemark"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: model.appealRequestRemark,
                                        "onUpdate:value": (value) => (model.appealRequestRemark = value),
                                        disabled: conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } }),
                                        placeholder: i18n.global.t("model.licenseRequest.appealRequestRemarkPlaceholder")
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                        createFieldAttachment({
                            key: `${prefix}attachmentAppealRequests`,
                            colProp: () => ({ xs: 24, md: 12 }),
                            formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                            label: () => i18n.global.t("model.license.attachment"),
                            inputProp: ({ field }) =>
                                lodash.merge(
                                    {
                                        value: modelRef.attachmentAppealRequests,
                                        "onUpdate:value": (value) => (modelRef.attachmentAppealRequests = value),
                                        disabled: conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } }),
                                        multiple: true,
                                        group: "AppealRequestAttachment",
                                    },
                                    conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                                ),
                        }),
                    ]}),
                    skeleton: isLoading.value,
                }),
            }),
        ],
    });
};

export const createLogFishingToolRequests = ({ data, key }) => {
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            {
                key: `${prefix}fishingToolRequests`,
                label: () => i18n.global.t("model.fishingToolRequest.title"),
                changeLog: {
                    getValueChildren: ({ record }) => {
                        let fishingToolRequest = `${i18n.global.t("model.fishingToolRequest.fishingToolName")}: ${record.fishingToolName}`;
                        if (record.refFishingTool) {
                            fishingToolRequest += `, ${i18n.global.t("model.fishingToolRequest.refFishingTool")}: ${record.refFishingTool?.nameTh}`;
                        }
                        fishingToolRequest += `, ${i18n.global.t("model.fishingToolRequest.qty")}: ${record.qty}`;
                        if (record.firstSubQty) {
                            fishingToolRequest += `, ${i18n.global.t("model.fishingToolRequest.firstSubQty")}: ${record.firstSubQty}`;
                        }
                        if (record.secondSubQty) {
                            fishingToolRequest += `, ${i18n.global.t("model.fishingToolRequest.secondSubQty")}: ${record.secondSubQty}`;
                        }
                        if (record.width) {
                            fishingToolRequest += `, ${i18n.global.t("model.fishingToolRequest.width")}: ${record.width}`;
                        }
                        if (record.monthStartFishing) {
                            fishingToolRequest += `, ${i18n.global.t("model.fishingToolRequest.monthStartFishing")}: ${record.monthStartFishing}`;
                        }
                        if (record.monthEndFishing) {
                            fishingToolRequest += `, ${i18n.global.t("model.fishingToolRequest.monthEndFishing")}: ${record.monthEndFishing}`;
                        }

                        return fishingToolRequest;
                    },
                },
            },
            {
                key: `${prefix}refVesselRequest.vesselOwnerRequests`,
                label: () => i18n.global.t("views.vesselOwner.title"),
                changeLog: {
                    getValueChildren: ({ record }) => {
                        let vesselOwnerRequests = `${i18n.global.t("model.vesselOwner.fullName")}: ${record.firstName} \n`;
                        if (record.addr) {
                            vesselOwnerRequests += `, ${i18n.global.t("model.vesselOwner.addr")}: ${record.addr}`;
                        }
                        if (record.ownershipDate) {
                            vesselOwnerRequests += `, ${i18n.global.t("model.vesselOwner.ownershipDate")}: ${ dateFormat({ text: record.ownershipDate, format: "DD/MM/YYYY" })}`;
                        }

                        return vesselOwnerRequests;
                    },
                },
            },
 
        ],
    });
};
